import React, { useMemo } from 'react';
import { Button } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import ModalML from '../ModalML/NewModalML';
import PublicModalStyled from './PublicModalStyled';

export default ({
  open,
  setOpen,
  handleCancel,
  title,
  onClose = () => {},
  tableList = [],
  chooseIds = [],
  total,
  pages,
  columns = [],
  children,
  pageData,
  changePage = () => {},
  singleSelect,
  handleChooseSuccess = () => {},
  clickSearch,
}) => {
  //弹框的取消按钮
  const handleClose = () => {
    setOpen(false);
    handleCancel && handleCancel();
  };
  //弹框的确定按钮
  const handleSubmit = () => {
    setOpen(false);
    handleChooseSuccess && handleChooseSuccess();
  };
  //弹框的底部按钮
  const footContent = (
    <div className="modal-btn-wrap">
      <Button onClick={handleClose} variant="contained" color="secondary">
        取消
      </Button>
      <Button
        variant="contained"
        className="btnSubmit button"
        onClick={handleSubmit}
      >
        确认
      </Button>
    </div>
  );
  const hasNext = useMemo(() => {
    if (tableList.length < pageData.pageSize) {
      return false;
    }
    return pageData.pageSize * pageData.pageNum < total;
  }, [pageData.pageSize, pageData.pageNum, clickSearch]);

  return (
    <ModalML
      open={open}
      setOpen={setOpen}
      onCancel={handleCancel}
      title={title}
      onClose={onClose}
    >
      <PublicModalStyled>
        {children}
        <div className="public-modal-list">
          <DataTableNativeML
            columns={columns}
            changePage={changePage}
            page={pageData}
            data={tableList}
            total={total}
            devicesMinWidth="auto"
            chooseIds={chooseIds}
            paging={true}
            columnKey="id"
            FootContent={footContent}
            initP={true}
            hasNext={hasNext}
            showPagingData={{ status: true, marginTop: '24px' }}
            showPageColor={true}
            pages={pages}
            np={true}
            singleSelect={singleSelect}
          ></DataTableNativeML>
        </div>
      </PublicModalStyled>
    </ModalML>
  );
};
